"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpaModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const typeorm_1 = require("@nestjs/typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard");
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const tpa_address_entity_1 = require("../../../../service-lib/src/lib/entities/tpa-address.entity");
const tpa_contact_entity_1 = require("../../../../service-lib/src/lib/entities/tpa-contact.entity");
const tpa_entity_1 = require("../../../../service-lib/src/lib/entities/tpa.entity");
const lookup_validation_1 = require("../../../../service-lib/src/lib/utils/lookup-validation");
const address_module_1 = require("../address/address.module");
const contact_module_1 = require("../contact/contact.module");
const tpa_controller_1 = require("./tpa.controller");
const tpa_repository_1 = require("./tpa.repository");
const tpa_service_1 = require("./tpa.service");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils//masters-validation");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let TpaModule = class TpaModule {
};
exports.TpaModule = TpaModule;
exports.TpaModule = TpaModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([tpa_entity_1.Tpa, tpa_address_entity_1.TpaAddress, tpa_contact_entity_1.TpaContact, look_up_entity_1.LookUp]),
            address_module_1.AddressModule,
            contact_module_1.ContactModule,
            jwt_1.JwtModule,
        ],
        providers: [
            tpa_service_1.TpaService,
            tpa_repository_1.TpaRepository,
            entity_service_utils_1.EntityService,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            lookup_validation_1.LookUpValidationService,
            masters_validation_1.MasterValidationService,
            scope_utils_1.ScopeService
        ],
        controllers: [tpa_controller_1.TpaController],
    })
], TpaModule);
